import { Ng1StateDeclaration } from '@uirouter/angularjs';
import * as Resolve from '../Resolve';

import { Roles } from '../../common';

const states: Ng1StateDeclaration[] = [{
    component: 'wtValidationStandAlone',
    name: 'validation',
    url: '/validation/:groupGuid?/:beginDate?/:endDate?',
    resolve: {
        auth: Resolve.authResolve,
        connected: Resolve.connectedResolve,
        roles: Resolve.rolesResolve(Roles.manualInputRoles),
        group: Resolve.groupResolve,
        appConfiguration: Resolve.appConfigurationResolve,
        share: [() => (this as any).share]
    },
    params: {
        groupGuid: {
            dynamic: true,
            value: ''
        },
        beginDate: '',
        endDate: ''
    },
    data: {
        editRoles: [Roles.master, Roles.operator],
        editButtonVisibility: () => false,
        displayName: 'Validation',
        icon: 'fa-check-square-o',
        breadcrumbs: {
            level4: ''
        }
    }
}];

export default states;